// PATCH 37 Mi8 — inline, specific validation shown on blur (not on every keystroke).
export default function FieldError({ msg, testid = "field-error" }) {
  if (!msg) return null;
  return (
    <span data-testid={testid} role="alert"
      style={{ display: "inline-flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--muted)",
        marginTop: 4, fontWeight: 600 }}>
      <span aria-hidden="true" style={{ fontWeight: 700 }}>!</span> {msg}
    </span>
  );
}
